/*global $html, beforeBelay, jQuery, personAnalyticsTrackClick */
/****************************************
	family-card.js
*****************************************/
(function ($) {
	'use strict';
	/* Toggle Siblings */
	$html
		.off('click', '.toggleSiblingsButton')
		.on('click', '.toggleSiblingsButton', function () {
			if ($html.hasClass('pFShowingSiblings')) {
				/* Hide Siblings */
				$(this).attr('aria-expanded', 'false');
				$html.removeClass('pFShowingSiblings');
				personAnalyticsTrackClick('showSiblings');
			} else {
				/* Show Siblings */
				$html.addClass('pFShowingSiblings');
				personAnalyticsTrackClick('showSiblings');
				$(this)
					.attr('aria-expanded', 'true')
					.closest('section')
					.find('.toggleSiblings > ul > li:first-child a')
					.focus();
			}
			/* Check Belay (Facts) */
			if (($('.factItemFocused').length) && (typeof (beforeBelay) === 'function')) {
				beforeBelay(false);
			}
		});
}(jQuery));